/**
 * ---------------------------------------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * ---------------------------------------------------------------------------------------------
 */

import { makeStyles, tokens } from '@fluentui/react-components';
import React, { ReactNode } from 'react';

import { Grid } from '@tdp/common/fluentV9MigrationComponents';

import { IToolTile, ToolTile } from './ToolTile';

export interface IToolTileLayout {
  tiles: IToolTile[];
}

const useStyle = makeStyles({
  inner: {
    position: 'relative',
    color: tokens.colorNeutralForeground1,
    minHeight: '100px',
    maxHeight: '120px',
    minWidth: '640px',
    paddingLeft: '15px',
    alignItems: 'center',
    gap: '20px',
  },
  textWrap: {
    paddingRight: '25px',
    gap: '8px',
  },
  iconWrap: {
    width: '64px',
    marginRight: '12px',
  },
  box: {
    width: '64px',
    height: ' 64px',
    borderRadius: '8px',
  },
  icon: {
    borderRadius: '6px',
  },
  title: {
    fontWeight: 700,
    lineHeight: '20px',
    fontSize: '16px',
  },
  descr: {
    fontWeight: 400,
    lineHeight: '16px',
    paddingTop: '2px',
    fontSize: '14px',
    color: tokens.colorNeutralForeground1,
  },
  extra: {
    position: 'absolute',
    right: '20px',
    top: '33%',
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(610px, 1fr))',
    gap: '12px',
    margin: '0 12px 0 0'
  },
});

export const ToolTileLayout: React.FC<IToolTileLayout> = ({ tiles }) => {
  const toolTileClasses = useStyle();
  return (
    <div
      className={toolTileClasses.grid}
      data-testid="resource-section"
    >
      {tiles.map(
        (tile: IToolTile): ReactNode => (
          <ToolTile {...tile} key={tile.title} />
        )
      )}
    </div>
  );
};
